import { DataProvider } from 'react-admin'

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) => Promise.resolve({ data: {}, total: 0 }),
} as DataProvider

export default provider
